import React, {useEffect, useState} from "react";
import http from "../../../components/plugins/axios";
import ChartService from "./chart/ChartService";
import TableService from "./table/TableService";
import {makeUrl} from "../../../util/BuyersSellersUtil";
import Head from "next/head";
import {getBahabinText, getTitleFaIranFinancialMarkets} from "../../../util/DominantUtil";

export default function BuyersSellers() {
    const [data, setData] = useState(null);
    const [sectors, setSectors] = useState(null);
    const [lastUpdate, setLastUpdate] = useState(null);
    const [byValue, setByValue] = useState(false);
    const [byGics, setByGics] = useState(false);

    useEffect(() => {
        callAPI()
    }, [])

    function callAPI(byValue = false, byGics = false) {
        setByValue(byValue)
        setByGics(byGics)
        http
            .get(makeUrl(null, byValue, byGics))
            .then((response) => {
                const data = response.data.data
                setData(data)
                if (!byValue) setSectors(Object.keys(data).map(key => data[key].name))
                setLastUpdate(response.data.lastUpdate)
            })
            .catch((error) => {
            });
    }

    return (
        <>
            <Head>
                <title>{getTitleFaIranFinancialMarkets('تحرکات حقیقی و حقوقی') + getBahabinText()}</title>
            </Head>
            <ChartService data={data} sectors={sectors} byValue={byValue}/>
            <TableService sectors={sectors} byValue={byValue} byGics={byGics} lastUpdate={lastUpdate}
                          callBack={callAPI}/>
        </>
    )
}